import React, { ReactElement, useEffect } from 'react'
import { useZocksIntercom } from './hooks/useZocksIntercom'
import { useLocation } from 'react-router-dom'

export interface IntercomWrapperProps {
  children?: ReactElement
}
export const IntercomWrapper: React.FC<IntercomWrapperProps> = ({ children }) => {
  const { updateLastRequest } = useZocksIntercom()
  const location = useLocation()

  useEffect(() => {
    updateLastRequest()
  }, [location])

  return <>{children}</>
}
